<template>
  <q-form ref="editForm">
    <c-card title="사업장 컴포넌트" height="700px" class="cardClassDetailForm">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant
            :editable="editable"
            label="기본"
            name="col1"
            v-model="data.col1">
          </c-plant>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant
            :editable="editable"
            label=""
            name="col1"
            v-model="data.col1">
          </c-plant>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant
            :required="true"
            :editable="editable"
            label="필수값"
            name="col1"
            v-model="data.col1">
          </c-plant>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant
            :disabled="true"
            :editable="editable"
            label="disable"
            name="col1"
            v-model="data.col1">
          </c-plant>
        </div>
      </template>
    </c-card>
  </q-form>
</template>

<script>
export default {
  name: 'plant',
  data() {
    return {
      editable: true,
      data: {
        col1: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
  }
};
</script>
